module.exports = __webpack_public_path__ + "img/b5.0680b453.jpg";